export default "__VITE_ASSET__d9d6258e__"